export const SEARCH = 'Search';
export const SEARCH_ICON_SIZE = '20px';
export const CLOSE_ICON_SIZE = '20px';
